import apiService from './apiService';

/**
 * Busca as notificações do usuário logado.
 */
export const getNotifications = () => {
    return apiService.get('/core/notificacoes/');
};

/**
 * Marca uma notificação específica como lida.
 * @param {string} notificationId - O ID da notificação.
 */
export const markAsRead = (notificationId) => {
    return apiService.post(`/core/notificacoes/${notificationId}/marcar-como-lida/`);
};

/**
 * Marca uma notificação específica como não lida.
 * @param {string} notificationId - O ID da notificação.
 */
export const markAsUnread = (notificationId) => {
    return apiService.post(`/core/notificacoes/${notificationId}/marcar-como-nao-lida/`);
};

/**
 * Exclui uma notificação (apenas o dono pode excluir).
 * @param {string} notificationId - O ID da notificação.
 */
export const deleteNotification = (notificationId) => {
    return apiService.delete(`/core/notificacoes/${notificationId}/`);
};

/**
 * Marca todas as notificações do usuário como lidas.
 */
export const markAllAsRead = () => {
    return apiService.post('/core/notificacoes/marcar-todas-como-lidas/');
};

/**
 * Central de notificações: matriz categoria × canal do usuário.
 * @returns {Promise<{canais, grupos, categorias, telegram_vinculado, push}>}
 */
export const getNotificationPreferences = () => {
    return apiService.get('/core/notificacoes/preferencias/').then((r) => r.data);
};

/**
 * Altera uma célula (ou lista de células) da matriz de preferências.
 * @param {{categoria: string, canal: string, valor: boolean} | {itens: Array}} payload
 */
export const updateNotificationPreference = (payload) => {
    return apiService.patch('/core/notificacoes/preferencias/', payload).then((r) => r.data);
};